<template>
    <div class="HeaderPanel">
        <div class="HeaderPanel__list">
            <div
                    v-for="({name, text, param, secondary, icon}, index) of list"
                    :class="[
                        'HeaderPanel__item',
                        {'HeaderPanel__item--secondary': secondary},
                        {'HeaderPanel__item--active': isObjectsPage && globalFilter === param}
                        ]"
                    :key="index"
                    @click="setFilter(param)"
            >
                <component :is="icon" class="HeaderPanel__icon hide-tablet-only"/>
                <div class="HeaderPanel__info">
                    <div class="HeaderPanel__text">{{name}}</div>
                    <div class="HeaderPanel__amount">{{text}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import HomeIcon from '@/assets/image/icons/home.svg?inline'
import EyeIcon from '@/assets/image/icons/eye.svg?inline'
import LikeIcon from '@/assets/image/icons/dislike.svg?inline'
import DislikeIcon from '@/assets/image/icons/like.svg?inline'
import {mapMutations, mapState} from "vuex";
import filterTypes from "@/constants/filterTypes";

const objectsPageList = ['object-list', 'object-group-list', 'object-map']

export default {
    name: "HeaderPanel",
    components: {
        HomeIcon,
        EyeIcon,
        LikeIcon,
        DislikeIcon,
    },
    data: () => ({
        /*list: [
            {
                name: 'Объекты',
                text: 100,
                param: null,
                icon: HomeIcon,
            },
            {
                name: 'Был показ',
                text: 11,
                param: filterTypes.shown,
                icon: EyeIcon,
            },
            {
                name: 'Не понравились',
                text: 999,
                icon: LikeIcon,
                param: filterTypes.disliked
            },
            {
                name: 'Понравились',
                text: 11,
                param: 'liked',
                icon: DislikeIcon,
                secondary: filterTypes.liked
            },

        ],*/
        activeItem: 'all',
    }),
    computed: {
        isObjectsPage() {
            return objectsPageList.includes(this.$route.name);
        },
        list: function(){
            return  [
                {
                    name: 'Объекты',
                    text: this.$store.state.cabinet.all,
                    param: null,
                    icon: HomeIcon,
                },
                {
                    name: 'Был показ',
                    text: this.$store.state.cabinet.shown,
                    param: filterTypes.shown,
                    icon: EyeIcon,
                },
                {
                    name: 'Не понравились',
                    text: this.$store.state.cabinet.dislikes,
                    icon: LikeIcon,
                    param: filterTypes.disliked
                },
                {
                    name: 'Понравились',
                    text: this.$store.state.cabinet.likes,
                    param: 'liked',
                    icon: DislikeIcon,
                    secondary: filterTypes.liked
                },
            ]
        },
        ...mapState(['globalFilter'])
    },
    methods: {
        setFilter(filter) {
            this.setGlobalFilter(filter);
            if(this.$route.name !== 'object-list') {
                this.$router.push({name:'object-list'})
            }
        },
        ...mapMutations(['setGlobalFilter'])
    }
}
</script>

<style lang="scss">
.HeaderPanel {
  height: 46px;

  overflow-x: auto;

  @include tablet {
    height: 48px;
  }

  @include mobile {
    height: 44px;
  }

  &__list {
    display: flex;
    align-items: stretch;
    height: inherit;
  }

  &__item {
    cursor: pointer;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    color: $primary;
    border-radius: 8px;
    @include svgFill($primary);
    padding: 0 12px;
    transition: 250ms;

    svg path.stroke {
      stroke: $primary;
      fill: none;
    }

    @include mobile {
      border-radius: 4px;
    }

    &:hover:not(&--active) {
      background-color: $primaryTransparent;
    }

    &--active {
      background-color: $primary;
      color: $white;
      @include svgFill($white);
      svg path.stroke {
        stroke: $white;
        fill: none;
      }

      @include mobile {
        .HeaderPanel__text {
          display: block;
        }

        .HeaderPanel__icon {
          display: none;
        }
      }
    }

    &--secondary {
      background: none;
      color: $secondary;
      @include svgFill($secondary);

      &:hover:not(.HeaderPanel__item--active) {
        background-color: $secondaryTransparent;
      }

      .HeaderPanel__amount {
        background-color: $secondaryLight;
        color: $secondary;
      }

      &.HeaderPanel__item--active {
        background-color: $secondary;
        color: $white;
        @include svgFill($white);
      }
    }
  }

  &__info {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  &__text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-left: 8px;

    @include tablet {
      font-size: 14px;
      line-height: 20px;
    }

    @include mobile {
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
    }

    @include mobile {
      display: none;
    }
  }

  &__amount {
    background-color: $primaryLight;
    color: $primary;
    padding: 4px 8px;
    border-radius: 25px;
    margin-left: 8px;
  }
}
</style>